/**
 * カート／レジ／完了のシートの器（M1.9b・D-101＝Design の k:"cart"→"checkout"→"done" の流れ）。
 *
 * 状態は `cartUi.tsx`、中身は pages/（Cart / Checkout / Done）＝この部品は
 * **どのシートを出すかと、閉じ方の規律**だけを持つ：
 * - カート・レジ＝背景タップ・×で閉じられる（買い物の途中でやめるのは普通の操作）。
 * - **完了だけ閉じられない**（dismissable=false）＝受付番号を控える前の誤タップを防ぐ。
 *   抜け道はボタン2つ（注文履歴へ／買い物を続ける）。
 */

import type { ConnectedTenant, partnerApi } from "@kenzai/api-client";
import { useNavigate } from "react-router-dom";

import { useCartUi } from "./cartUi";
import { CartSheetBody } from "./pages/Cart";
import { CheckoutSheetBody } from "./pages/Checkout";
import { DoneSheetBody } from "./pages/Done";
import { Sheet } from "./Sheet";

type Client = ReturnType<typeof partnerApi>;

export function CartSheets({ client, connections }: { client: Client; connections: ConnectedTenant[] }) {
  const ui = useCartUi();
  const nav = useNavigate();

  if (ui.mode === null) return null;

  if (ui.mode.k === "cart") {
    return (
      <Sheet label="カート" onClose={ui.close} testId="cart-sheet">
        <CartSheetBody client={client} connections={connections} />
      </Sheet>
    );
  }

  if (ui.mode.k === "checkout") {
    return (
      <Sheet label="発注内容の確認" onClose={ui.close} testId="checkout-sheet">
        <CheckoutSheetBody client={client} connections={connections} />
      </Sheet>
    );
  }

  return (
    <Sheet label="発注が完了しました" onClose={ui.close} testId="done-sheet" dismissable={false}>
      <DoneSheetBody
        result={ui.mode.result}
        meta={ui.mode.meta}
        onGoOrders={() => {
          ui.close();
          nav("/orders");
        }}
        onClose={ui.close}
      />
    </Sheet>
  );
}
